// client/src/core/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(HttpApi) // Loads translations via HTTP
    .use(LanguageDetector) // Detects user language
    .use(initReactI18next) // Passes i18n instance to react-i18next
    .init({
        supportedLngs: ['en', 'fr', 'ar'], // Define supported languages
        fallbackLng: 'en', // Use 'en' if detected language is not available
        debug: process.env.NODE_ENV === 'development', // Only show logs in development

        ns: ['translation'], // Default namespace
        defaultNS: 'translation',

        detection: {
            order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage', 'cookie'], // Where to cache detected language
            lookupLocalStorage: 'language-preference',
            lookupCookie: 'language-preference',
        },

        backend: {
            // Path to load translations from the 'public' folder
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        },

        react: {
            // Explicitly enable Suspense (this is the default, but good to be clear)
            useSuspense: true
        }
    });

export default i18n;